import { SxProps, stepLabelClasses, stepClasses } from '@mui/material'

interface StepperStyles {
  stepper: SxProps
  step: SxProps
  stepLabel: SxProps
  activeBorder: SxProps
}

const labelColor = 'text.hyperLink'
const baseLabelColor = 'utils.gray700'

export const stepperStyles: StepperStyles = {
  stepper: {
    borderBottom: { lg: 'none', xl: '1px solid' },
    borderBottomColor: { lg: 'transparent', xl: 'border.secondary' },

    [`.${stepClasses.root}`]: {
      p: 2,
    },
  },

  step: {
    textAlign: 'center',
    borderTop: '4px solid',
    transition: 'all 0.2s ease-in-out',
    borderColor: 'transparent',
  },

  activeBorder: {
    borderColor: labelColor,
  },

  stepLabel: {
    [`.${stepLabelClasses.iconContainer}`]: {
      display: 'none',
    },
    [`.${stepLabelClasses.label}.${stepLabelClasses.alternativeLabel}`]: {
      mt: 0,
    },
    [`& .${stepLabelClasses.label}`]: {
      typography: 'textSmSemibold',
      color: baseLabelColor,

      '&.Mui-active, &.Mui-completed': {
        color: labelColor,
        typography: 'textSmSemibold',
      },
    },
  },
}
